<template>
        <div>
            <div class="custom-control custom-checkbox" style="padding-top: 5px;" @click="toggleCheck" >
                <input type="checkbox" class="custom-control-input"
                       :name="checkboxname" :checked="isChecked">
                <label class="custom-control-label">{{ title }}</label>
            </div>

            <!-- Material switch -->
            <div class="switch switch-info" @click="toggleFilter">
                <label>
                    No
                    <input :id="id" type="checkbox" :value="checked"
                           :name="switchname" v-model="checked"
                           :disabled="isDisabled" @change="updateFilter">
                    <span class="lever"></span> Yes
                </label>
            </div>
        </div>
</template>

<script>
    export default {
        props: ['id', 'title', 'value'],

        data() {
            return {
                isDisabled: true,
                isChecked: false,
                checked: false,
            }
        },

        mounted() {
            $(document).on('reset', this.reset)

            // if returned here using back button reset filter based on
            // previous values.
            if (this.value !== '') {
                this.isDisabled = false
                this.isChecked = false

                if (this.value === 'true')
                    this.checked = true
                else this.checked = false

                this.updateFilter()
            }
        },

        computed: {
            checkboxname() {
                return "checkbox_" + this.id
            },
            switchname() {
                return "switch_" + this.id
            }
        },

        methods: {
            toggleCheck() {
                this.isChecked = !this.isChecked
                this.isDisabled = !this.isDisabled

                if (! this.isChecked) {
                    // if filter has been turned off broadcastEvent to remove
                    // filter
                    this.broadcastEvent()
                } else {
                    // possible that check box was reactivated
                    this.updateFilter()
                }
            },

            toggleFilter() {
                // if the checkbox to disable filter is not set and
                // user clicks on the UI, then first set the checkbox for
                // the UI to true and then enable the filter
                if (! this.isChecked) {
                    this.isDisabled = false
                    this.isChecked = true
                }
            },

            updateFilter() {
                // the switched was turned on or off either case.
                // broadcast the event to update datatables.

                this.broadcastEvent(this.checked)
            },

            broadcastEvent(val='') {
                $(document).trigger('ToggleSwitch', [{'flag': val,
                                                      'id': this.id}])
            },

            reset() {
                this.isDisabled = true;
                this.isChecked = false;
                this.checked = false;
            }
        }
    }
</script>
